import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaSearch, FaBriefcase, FaArrowRight } from 'react-icons/fa';
import './JobsServed.css';

const ALL_JOBS = [
  { title: 'Civil Engineer', category: 'Engineering', icon: '🏗️' },
  { title: 'Mechanical Engineer', category: 'Engineering', icon: '⚙️' },
  { title: 'Electrical Engineer', category: 'Engineering', icon: '⚡' },
  { title: 'Store Keeper', category: 'Logistics', icon: '📦' },
  { title: 'Teacher', category: 'Education', icon: '📚' },
  { title: 'Warehouse Supervisor', category: 'Logistics', icon: '🏭' },
  { title: 'Automobile Mechanic', category: 'Automotive', icon: '🚗' },
  { title: 'IT Technician', category: 'Technology', icon: '💻' },
  { title: 'General Worker', category: 'Labour', icon: '👷' },
  { title: 'Chef', category: 'Hospitality', icon: '👨‍🍳' },
  { title: 'Accountant', category: 'Finance', icon: '📊' },
  { title: 'Logistics Coordinator', category: 'Logistics', icon: '🚚' },
  { title: 'Driver', category: 'Transport', icon: '🚌' },
  { title: 'Nurse', category: 'Healthcare', icon: '🏥' },
  { title: 'Occupational Therapist', category: 'Healthcare', icon: '🩺' },
  { title: 'Waiter', category: 'Hospitality', icon: '🍽️' },
  { title: 'HR Officer', category: 'Administration', icon: '👥' },
  { title: 'Restaurant Cleaner', category: 'Hospitality', icon: '🧹' },
  { title: 'Cashier', category: 'Retail', icon: '💰' },
  { title: 'Safety Officer', category: 'Engineering', icon: '🦺' },
  { title: 'Sales Executive', category: 'Sales', icon: '📈' },
  { title: 'Agriculture Worker', category: 'Agriculture', icon: '🌾' },
  { title: 'Farmer', category: 'Agriculture', icon: '🚜' },
  { title: 'Welder', category: 'Construction', icon: '🔧' },
  { title: 'Painter', category: 'Construction', icon: '🎨' },
  { title: 'Carpenter', category: 'Construction', icon: '🪚' },
  { title: 'Documentation Officer', category: 'Administration', icon: '📋' },
  { title: 'Speech Therapist', category: 'Healthcare', icon: '🗣️' },
  { title: 'Digital Marketing Specialist', category: 'Technology', icon: '📱' },
  { title: 'Plumber', category: 'Construction', icon: '🔩' },
  { title: 'Greenhouse Technician', category: 'Agriculture', icon: '🌿' },
  { title: 'Car Mechanic', category: 'Automotive', icon: '🔨' },
  { title: 'Heavy Vehicle Mechanic', category: 'Automotive', icon: '🚛' },
  { title: 'Kitchen Helper', category: 'Hospitality', icon: '🥘' },
  { title: 'Warehouse Picker', category: 'Logistics', icon: '📫' },
  { title: 'Restaurant Shift Manager', category: 'Hospitality', icon: '🍴' },
  { title: 'Security Guard', category: 'Security', icon: '🛡️' },
  { title: 'Front Office Supervisor', category: 'Administration', icon: '🏨' },
  { title: 'AC Technician', category: 'Construction', icon: '❄️' },
  { title: 'Tea Master', category: 'Hospitality', icon: '☕' },
  { title: 'Mason', category: 'Construction', icon: '🧱' },
  { title: 'Delivery Boy', category: 'Transport', icon: '📬' },
];

const CATEGORIES = ['All', ...Array.from(new Set(ALL_JOBS.map(j => j.category))).sort()];

const JobsServed = () => {
  const [search, setSearch] = useState('');
  const [activeCategory, setActiveCategory] = useState('All');
  const navigate = useNavigate();

  const filtered = ALL_JOBS.filter(j => {
    const matchCat = activeCategory === 'All' || j.category === activeCategory;
    const matchSearch = j.title.toLowerCase().includes(search.toLowerCase());
    return matchCat && matchSearch;
  });

  return (
    <div className="jobs-served-page">
      {/* Hero */}
      <div className="js-hero">
        <div className="container text-center">
          <div className="js-badge"><FaBriefcase /> Roles We Place</div>
          <h1>Jobs We <span>Serve</span></h1>
          <p>Pavishna Global Services specializes in placing professionals across a wide range of industries for international opportunities.</p>
          <div className="js-search">
            <FaSearch />
            <input
              type="text" placeholder="Search a job role..."
              value={search} onChange={e => setSearch(e.target.value)}
            />
          </div>
        </div>
      </div>

      <div className="container">
        {/* Category Filter */}
        <div className="category-filter">
          {CATEGORIES.map(cat => (
            <button key={cat} className={`cat-btn${activeCategory === cat ? ' active' : ''}`} onClick={() => setActiveCategory(cat)}>
              {cat}
            </button>
          ))}
        </div>

        <div className="js-count">{filtered.length} roles{search && ` matching "${search}"`}</div>

        {/* Jobs Grid */}
        <div className="js-grid">
          {filtered.map((job, i) => (
            <div key={i} className="js-card" onClick={() => navigate(`/jobs?search=${encodeURIComponent(job.title)}`)}>
              <div className="js-icon">{job.icon}</div>
              <div className="js-card-content">
                <h3>{job.title}</h3>
                <span className="js-category">{job.category}</span>
              </div>
              <FaArrowRight className="js-arrow" />
            </div>
          ))}
        </div>

        {filtered.length === 0 && (
          <div className="no-roles">
            <p>No roles found for "<strong>{search}</strong>"</p>
            <button onClick={() => setSearch('')} className="btn-primary">Clear Search</button>
          </div>
        )}

        {/* CTA */}
        <div className="js-cta">
          <div className="js-cta-content">
            <h2>Don't see your role listed?</h2>
            <p>We handle many more positions. Contact us directly and we'll find the right opportunity for you.</p>
            <button className="btn-primary" onClick={() => navigate('/contact')}>
              Contact Us <FaArrowRight />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JobsServed;
